import { getVoyageNumber } from "../../../utils/domainSelectors";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

export const createObqRobPrintViewModelV2 = ({
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  companyLogo,
  cargoData,
  isLiquid,
  isResidues,
  totalVolume,
  totalMt,
  draft,
  t,
}) => {
  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  if (!selectedCargo) {
    throw new Error("Please select a cargo before printing.");
  }

  return {
    companyLogo: companyLogo || "",
    vesselName: currentVoyage?.vessel || "\u2014",
    title: t("title"),
    voyageNumber: getVoyageNumber(currentVoyage) || "\u2014",
    tripDate: selectedTrip?.date || "\u2014",
    portName: selectedTrip?.from || "\u2014",
    jettyName: selectedTrip?.jetty || "\u2014",
    condition:
      selectedTrip?.operationType === "Loading"
        ? t("voyageInfo.beforeLoading")
        : t("voyageInfo.afterDischarge"),
    draft: draft || {},
    cargoData: Array.isArray(cargoData) ? cargoData : [],
    isLiquid,
    isResidues,
    totalVolume,
    totalMt,
  };
};
